export default __webpack_public_path__ + "static/accessories-5b61fabb6d7f56048e5607cbd706e801.webp";